(() => {
  const LIMIT = 6;
  const expandedOptions = new Set();
  const observedPickers = new WeakSet();
  const scheduledPickers = new WeakSet();

  const getOptionKey = (fieldset) => {
    const picker = fieldset.closest('variant-picker');
    const firstInput = fieldset.querySelector('input[data-option-name]');
    const productId = picker?.dataset.productId || 'product';
    const optionName = firstInput?.dataset.optionName || fieldset.dataset.fieldsetIndex || 'option';
    return `${productId}::${optionName}`;
  };

  const setAttributeIfChanged = (element, name, value) => {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  };

  const updateToggle = (fieldset, button, expanded, extraCount) => {
    const label = expanded ? 'Mai puține opțiuni' : `Mai multe opțiuni +${extraCount}`;
    if (button.textContent !== label) button.textContent = label;
    setAttributeIfChanged(button, 'aria-expanded', String(expanded));
    if (fieldset.dataset.expanded !== String(expanded)) fieldset.dataset.expanded = String(expanded);
  };

  const enhanceFieldset = (fieldset) => {
    if (!(fieldset instanceof HTMLFieldSetElement)) return;
    if (fieldset.classList.contains('variant-option--swatches')) return;

    const labels = Array.from(fieldset.children).filter(
      (child) => child instanceof HTMLLabelElement && child.classList.contains('variant-option__button-label')
    );

    if (labels.length <= LIMIT) return;

    const key = getOptionKey(fieldset);
    const extraCount = labels.length - LIMIT;
    const expanded = expandedOptions.has(key);

    fieldset.classList.add('variant-option--compact-grid');
    fieldset.dataset.compactVariant = 'true';

    if (!fieldset.id) {
      const productId = fieldset.closest('variant-picker')?.dataset.productId?.replace(/\D/g, '') || 'product';
      const fieldsetIndex = fieldset.dataset.fieldsetIndex || '0';
      fieldset.id = `CompactVariant-${productId}-${fieldsetIndex}`;
    }

    labels.forEach((label, index) => {
      label.classList.toggle('variant-option__button-label--compact-extra', index >= LIMIT);
    });

    let button = Array.from(fieldset.children).find(
      (child) => child instanceof HTMLButtonElement && child.matches('[data-variant-more]')
    );

    if (!(button instanceof HTMLButtonElement)) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'variant-option__compact-toggle';
      button.dataset.variantMore = '';
      button.setAttribute('aria-controls', fieldset.id);
      fieldset.append(button);
    }

    updateToggle(fieldset, button, expanded, extraCount);
  };

  const enhancePicker = (picker) => {
    if (!(picker instanceof Element)) return;
    picker.querySelectorAll('fieldset.variant-option--buttons').forEach(enhanceFieldset);
  };

  const schedulePicker = (picker) => {
    if (!(picker instanceof Element) || scheduledPickers.has(picker)) return;
    scheduledPickers.add(picker);
    window.requestAnimationFrame(() => {
      scheduledPickers.delete(picker);
      if (picker.isConnected) enhancePicker(picker);
    });
  };

  const observePicker = (picker) => {
    if (!(picker instanceof Element)) return;
    enhancePicker(picker);
    if (observedPickers.has(picker)) return;

    observedPickers.add(picker);
    const observer = new MutationObserver(() => schedulePicker(picker));
    observer.observe(picker, { childList: true, subtree: true });
  };

  const discoverPickers = (root) => {
    if (!(root instanceof Element || root instanceof Document)) return;
    if (root instanceof Element && root.matches('variant-picker')) observePicker(root);
    root.querySelectorAll?.('variant-picker').forEach(observePicker);
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target.closest('[data-variant-more]') : null;
    if (!(target instanceof HTMLButtonElement)) return;

    const fieldset = target.closest('[data-compact-variant]');
    if (!(fieldset instanceof HTMLFieldSetElement)) return;

    event.preventDefault();
    const key = getOptionKey(fieldset);
    const shouldExpand = fieldset.dataset.expanded !== 'true';

    if (shouldExpand) expandedOptions.add(key);
    else expandedOptions.delete(key);

    const extraCount = fieldset.querySelectorAll(':scope > .variant-option__button-label--compact-extra').length;
    updateToggle(fieldset, target, shouldExpand, extraCount);
  });

  const start = () => {
    const main = document.querySelector("#MainContent[data-template^='product']");
    if (!main) return;

    discoverPickers(main);

    const rootObserver = new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node instanceof Element) discoverPickers(node);
        }
      }
    });
    rootObserver.observe(main, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) discoverPickers(event.target);
  });
})();
